/* Kyma — statement word fill.
   Sets a single --reveal custom property (0..1) per statement as it crosses
   the viewport. Each word derives its own opacity in CSS, so scrolling never
   writes to the DOM per word. Honours prefers-reduced-motion. */

(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var items = [];
  var ticking = false;

  function collect(scope) {
    (scope || document).querySelectorAll('[data-kyma-statement]').forEach(function (el) {
      if (items.indexOf(el) === -1) items.push(el);
    });
    update();
  }

  function drop(scope) {
    items = items.filter(function (el) {
      return !scope || !scope.contains(el);
    });
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || 1;

    items.forEach(function (el) {
      if (RM.matches) {
        el.style.setProperty('--reveal', '1');
        return;
      }
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;

      // 0 when the block enters at 85% of the viewport, 1 by the time it
      // reaches 35% — the fill completes before the block leaves centre.
      var start = vh * 0.85;
      var end = vh * 0.35;
      var p = (start - r.top) / (start - end);
      el.style.setProperty('--reveal', Math.min(Math.max(p, 0), 1).toFixed(3));
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { collect(); });
  } else {
    collect();
  }

  document.addEventListener('shopify:section:load', function (e) { collect(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { drop(e.target); });

  var onPref = function () { update(); };
  if (RM.addEventListener) RM.addEventListener('change', onPref);
  else if (RM.addListener) RM.addListener(onPref);
})();
